/* ==========================================================================
   MISTER KEY — Shopify theme interactions
   Cart via Shopify AJAX API + Section Rendering. No localStorage.
   ========================================================================== */
(function () {
  "use strict";

  var CART_SECTION = "cart-drawer";
  var MK = window.MK || { money: "${{amount}}" };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var fmt = MK.money || "${{amount}}";
    function withDelims(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ","; decimal = decimal || ".";
      if (isNaN(number) || number == null) return "0";
      number = (number / 100).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var ph = match ? match[1] : "amount";
    var value;
    switch (ph) {
      case "amount_no_decimals": value = withDelims(cents, 0); break;
      case "amount_with_comma_separator": value = withDelims(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = withDelims(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = withDelims(cents, 2, " ", "."); break;
      case "amount_with_apostrophe_separator": value = withDelims(cents, 2, "'", "."); break;
      default: value = withDelims(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) { t = document.createElement("div"); t.id = "toast"; t.className = "toast"; document.body.appendChild(t); }
    t.innerHTML = '<svg class="icon"><use href="#i-check"></use></svg><span>' + msg + "</span>";
    requestAnimationFrame(function () { t.classList.add("show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- overlays / scrim ---------- */
  function scrim() { return document.getElementById("scrim"); }
  function releaseScrim() {
    if (!document.querySelector(".cart-drawer.open, .mobile-drawer.open, .filters.open")) {
      scrim() && scrim().classList.remove("show");
      document.body.style.overflow = "";
    }
  }
  function openCart() {
    var d = document.getElementById("cartDrawer");
    if (d) d.classList.add("open");
    scrim() && scrim().classList.add("show");
    document.body.style.overflow = "hidden";
  }
  function closeAll() {
    document.querySelectorAll(".cart-drawer.open, .mobile-drawer.open, .filters.open").forEach(function (el) { el.classList.remove("open"); });
    var sb = document.getElementById("searchBar"); if (sb) sb.classList.remove("open");
    releaseScrim();
  }

  /* ---------- cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n; el.classList.toggle("show", n > 0);
    });
  }

  /* ---------- cart: render from Section Rendering API ---------- */
  function applyCartSections(sections) {
    if (!sections || !sections[CART_SECTION]) return;
    var doc = new DOMParser().parseFromString(sections[CART_SECTION], "text/html");
    var fresh = doc.querySelector("#cartDrawerContent");
    var live = document.getElementById("cartDrawerContent");
    if (fresh && live) live.innerHTML = fresh.innerHTML;
    var newDrawer = doc.querySelector("#cartDrawer");
    if (newDrawer) {
      var count = parseInt(newDrawer.getAttribute("data-count"), 10) || 0;
      setCartCount(count);
      var liveDrawer = document.getElementById("cartDrawer");
      if (liveDrawer) liveDrawer.setAttribute("data-count", count);
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function cartAdd(variantId, qty) {
    return postJSON("/cart/add.js", {
      items: [{ id: variantId, quantity: qty || 1 }],
      sections: [CART_SECTION],
      sections_url: window.location.pathname
    }).then(function (data) {
      if (data.status) { toast(data.description || "Couldn’t add to cart"); return; }
      applyCartSections(data.sections);
      openCart();
      toast("Added to cart");
    }).catch(function () { toast("Couldn’t add to cart"); });
  }

  function cartChange(line, qty) {
    return postJSON("/cart/change.js", {
      line: line, quantity: qty,
      sections: [CART_SECTION], sections_url: window.location.pathname
    }).then(function (data) { applyCartSections(data && data.sections); });
  }

  /* ---------- chrome ---------- */
  function initChrome() {
    var header = document.getElementById("siteHeader");
    if (header) {
      var onScroll = function () { header.classList.toggle("scrolled", window.scrollY > 8); };
      onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
    }

    document.addEventListener("click", function (e) {
      if (e.target.closest(".announce-close")) { e.target.closest(".announce").classList.add("hide"); return; }

      var st = e.target.closest("#searchToggle");
      if (st) {
        var sb = document.getElementById("searchBar");
        var open = sb.classList.toggle("open");
        st.setAttribute("aria-expanded", open);
        if (open) setTimeout(function () { var i = sb.querySelector("input"); i && i.focus(); }, 120);
        return;
      }

      if (e.target.closest("#hamburger")) { document.getElementById("mobileDrawer").classList.add("open"); scrim().classList.add("show"); document.body.style.overflow = "hidden"; return; }
      if (e.target.closest("#drawerClose")) { document.getElementById("mobileDrawer").classList.remove("open"); releaseScrim(); return; }

      var macc = e.target.closest(".m-acc > button");
      if (macc) { macc.parentElement.classList.toggle("open"); return; }

      if (e.target.closest(".js-open-cart")) { e.preventDefault(); openCart(); return; }
      if (e.target.closest(".js-cart-close")) { closeAll(); return; }

      if (e.target.closest("#filterToggle")) { document.getElementById("filters").classList.add("open"); scrim().classList.add("show"); document.body.style.overflow = "hidden"; return; }
      if (e.target.closest("#filterClose")) { document.getElementById("filters").classList.remove("open"); releaseScrim(); return; }

      if (e.target === scrim()) { closeAll(); return; }

      var accHead = e.target.closest(".acc-head");
      if (accHead) { accHead.parentElement.classList.toggle("open"); return; }

      /* quick-add on product cards */
      var qa = e.target.closest(".js-quick-add");
      if (qa) { e.preventDefault(); if (qa.dataset.variantId) cartAdd(qa.dataset.variantId, 1); return; }

      /* cart drawer line controls (delegated — drawer content is re-rendered) */
      var inc = e.target.closest(".js-qty-inc"), dec = e.target.closest(".js-qty-dec"), rem = e.target.closest(".js-cart-remove");
      if (inc || dec) {
        var qEl = (inc || dec).closest(".qty");
        var line = parseInt(qEl.getAttribute("data-line"), 10);
        var cur = parseInt(qEl.querySelector("span").textContent, 10) || 1;
        cartChange(line, cur + (inc ? 1 : -1));
        return;
      }
      if (rem) { cartChange(parseInt(rem.getAttribute("data-line"), 10), 0); return; }
    });

    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

    /* newsletter handled natively by Shopify form; faceted filter auto-submit */
    var facetForm = document.getElementById("FacetForm");
    if (facetForm) {
      facetForm.addEventListener("change", function () { facetForm.submit(); });
    }
  }

  /* ---------- product page ---------- */
  function initProduct() {
    var root = document.getElementById("pdp");
    if (!root) return;

    /* gallery thumbs */
    root.querySelectorAll(".pdp-thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        root.querySelectorAll(".pdp-thumb").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        var main = document.getElementById("pdpMainImage");
        if (main && t.dataset.full) { main.srcset = ""; main.src = t.dataset.full; }
      });
    });

    /* qty steppers */
    var q = document.getElementById("Quantity");
    var dec = document.getElementById("qtyDec"), inc = document.getElementById("qtyInc");
    if (dec) dec.addEventListener("click", function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener("click", function () { q.value = (parseInt(q.value, 10) || 1) + 1; });

    /* variant picker */
    var dataEl = root.querySelector("[data-variants-json]");
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }
    var idInput = root.querySelector("[data-variant-id]");

    function selected() {
      return Array.prototype.slice.call(root.querySelectorAll("[data-opt-input]:checked"))
        .sort(function (a, b) { return a.name.localeCompare(b.name); })
        .map(function (i) { return i.value; });
    }
    function match(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      root.querySelectorAll("[data-opt-input]").forEach(function (i) {
        var wrap = i.closest(".opt-finish, .opt-pill"); if (wrap) wrap.classList.toggle("active", i.checked);
      });
      root.querySelectorAll("[data-option-selected]").forEach(function (el) {
        var grp = root.querySelector('[data-option-position="' + el.getAttribute("data-option-selected") + '"]');
        var c = grp && grp.querySelector("[data-opt-input]:checked");
        if (c) el.textContent = c.value;
      });
      var v = match(selected());
      var btn = root.querySelector("[data-add-btn]"), txt = root.querySelector("[data-add-text]");
      if (!v) { if (btn) btn.disabled = true; if (txt) txt.textContent = "Unavailable"; return; }
      if (idInput) idInput.value = v.id;
      var now = root.querySelector("[data-price-now]"), was = root.querySelector("[data-price-was]"), save = root.querySelector("[data-price-save]");
      if (now) now.textContent = formatMoney(v.price);
      if (v.compare_at_price > v.price) {
        if (was) { was.hidden = false; was.textContent = formatMoney(v.compare_at_price); }
        if (save) { save.hidden = false; save.textContent = "Save " + formatMoney(v.compare_at_price - v.price); }
      } else { if (was) was.hidden = true; if (save) save.hidden = true; }
      if (btn) btn.disabled = !v.available;
      if (txt) txt.textContent = v.available ? "Add to cart · " + formatMoney(v.price) : "Sold out";
      var sp = document.querySelector("[data-sticky-price]"); if (sp) sp.textContent = formatMoney(v.price);
      var sa = document.getElementById("stickyAdd"); if (sa) { sa.disabled = !v.available; sa.textContent = v.available ? "Add to cart" : "Sold out"; }
      if (v.featured_media && v.featured_media.preview_image) {
        var main = document.getElementById("pdpMainImage");
        if (main) { var s = v.featured_media.preview_image.src; main.srcset = ""; main.src = s + (s.indexOf("?") > -1 ? "&" : "?") + "width=1200"; }
      }
    }
    root.addEventListener("change", function (e) { if (e.target.matches("[data-opt-input]")) update(); });

    /* add to cart via AJAX */
    var form = document.getElementById("product-form");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var id = form.querySelector('[name="id"]').value;
        var qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
        var btn = form.querySelector("[data-add-btn]");
        if (btn) btn.disabled = true;
        cartAdd(id, qty).then(function () { if (btn) btn.disabled = false; });
      });
    }

    /* sticky buy bar — show once the main Add to Cart scrolls out of view */
    var sticky = document.getElementById("pdpSticky");
    var stickyTrigger = root.querySelector("[data-add-btn]");
    if (sticky && stickyTrigger && "IntersectionObserver" in window) {
      var sObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.classList.toggle("show", !e.isIntersecting); });
      }, { rootMargin: "0px 0px -64px 0px" });
      sObs.observe(stickyTrigger);
    }
    var stickyAdd = document.getElementById("stickyAdd");
    if (stickyAdd && form) {
      stickyAdd.addEventListener("click", function () {
        var sid = form.querySelector('[name="id"]').value;
        var sqty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
        stickyAdd.disabled = true;
        cartAdd(sid, sqty).then(function () { stickyAdd.disabled = false; });
      });
    }
  }

  /* ---------- hero carousel ---------- */
  function initCarousel() {
    var root = document.getElementById("heroCarousel");
    if (!root) return;
    var track = root.querySelector(".hero-track");
    var slides = Array.prototype.slice.call(root.querySelectorAll(".hero-slide"));
    var dotsWrap = root.querySelector(".hero-dots");
    var n = slides.length;
    if (!n || !track) return;
    var i = 0, timer = null;
    var autoplaySec = parseInt(root.getAttribute("data-autoplay"), 10);
    var delay = (isNaN(autoplaySec) ? 6 : autoplaySec) * 1000;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Later slides carry their background in data-bg so they don't compete with
    // the first slide (the LCP image) during page load. Applied on window load,
    // or immediately if the user navigates to one first.
    function applyBgs() {
      slides.forEach(function (s) {
        if (s.dataset.bg) { s.style.backgroundImage = "url('" + s.dataset.bg + "')"; delete s.dataset.bg; }
      });
    }
    if (document.readyState === "complete") applyBgs();
    else window.addEventListener("load", applyBgs);

    if (dotsWrap) {
      slides.forEach(function (s, idx) {
        var b = document.createElement("button");
        b.className = "hero-dot"; b.type = "button"; b.setAttribute("aria-label", "Go to slide " + (idx + 1));
        b.addEventListener("click", function () { go(idx); restart(); });
        dotsWrap.appendChild(b);
      });
    }
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

    function render() {
      track.style.transform = "translateX(-" + i * 100 + "%)";
      dots.forEach(function (d, x) { d.classList.toggle("active", x === i); });
      slides.forEach(function (s, x) { s.inert = x !== i; s.setAttribute("aria-hidden", x !== i ? "true" : "false"); });
      if (dotsWrap) { dotsWrap.classList.remove("on-light", "on-dark"); dotsWrap.classList.add(slides[i].dataset.tone === "light" ? "on-light" : "on-dark"); }
    }
    function go(to) { applyBgs(); i = (to % n + n) % n; render(); }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function start() { if (reduce || n < 2 || delay <= 0) return; stop(); timer = setInterval(next, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    var nx = root.querySelector(".hero-nav.next"), pv = root.querySelector(".hero-nav.prev");
    if (nx) nx.addEventListener("click", function () { next(); restart(); });
    if (pv) pv.addEventListener("click", function () { prev(); restart(); });
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else start(); });

    var x0 = null;
    root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); }
      x0 = null; start();
    }, { passive: true });

    render(); start();
  }

  /* ---------- cart attributes (PO number or job name) ----------
     Saved as soon as the field changes, so the value survives a cart drawer
     re-render or leaving the page before checkout. Enter saves instead of submitting. */
  function initCartAttributes() {
    document.addEventListener("change", function (e) {
      var f = e.target.closest && e.target.closest("[data-cart-attr]");
      if (!f) return;
      var attrs = {};
      attrs[f.getAttribute("data-cart-attr")] = f.value.trim();
      postJSON("/cart/update.js", { attributes: attrs }).catch(function () {});
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target.matches && e.target.matches("[data-cart-attr]")) { e.preventDefault(); e.target.blur(); }
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!("IntersectionObserver" in window) || !els.length) { els.forEach(function (e) { e.classList.add("is-visible"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initChrome();
    initProduct();
    initCarousel();
    initReveal();
    initCartAttributes();
  });
})();
